import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6608f6e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-client-type-page" }
const _hoisted_2 = { class: "select-business-client-type-component" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!
  const _component_OrderHeaderChangeActions = _resolveComponent("OrderHeaderChangeActions")!
  const _component_back_and_cancel_footer = _resolveComponent("back-and-cancel-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, { text: 'Select Order Client type' }),
    _createVNode(_component_OrderHeaderChangeActions, {
      productId: _ctx.productId,
      selected: 2
    }, null, 8, ["productId"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["item-box", { selected: !_ctx.clientExist }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeBusinessClient()))
        }, _toDisplayString(_ctx.$t("cashier.label.private")), 3)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["item-box", { selected: _ctx.clientExist }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ShowBusinessClients()))
        }, _toDisplayString(_ctx.$t("cashier.label.business-client")), 3)
      ])
    ]),
    _createVNode(_component_back_and_cancel_footer)
  ]))
}